import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getFlowConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.system.flowconfiguration'],
);

export const getFlowName = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.name']);

export const getFlowContext = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.contextflow']);

export const getActiveFlows = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.active']);

export const getDeactivatedFlows = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.deactivate'],
);

export const getMarkAsActive = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.markactive']);

export const getFlowCreated = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.msg.created']);

export const getFlowUpdated = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.msg.updated']);

export const getCreateFlow = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.create']);

export const getUpdateFlow = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.update']);

export const getSortContextFlow = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.flows.context_flow'],
);

export const getSortCreationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.flows.flow_creation_date'],
);

export const getSortFlowName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.flows.flow_name'],
);

export const getFlowConfigurationTitle = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.configurepanel.title'],
);

export const getHelpFlowConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['help.flowconfiguration'],
);

export const getContextFlow = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.contextflow'],
);

export const getFlowEvent = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.flowevent'],
);

export const getEditFlowEvent = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.editpanel.title'],
);

export const getJSONFailed = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.msg.jsonfailed'],
);

export const getServerError = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.msg.servererror'],
);

export const getSuccessfulValidation = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.msg.valid'],
);

export const getEditFlow = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.editflow']);

export const getEditFlowAdvanced = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.editflowadvanced'],
);

export const getMissingStart = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.msg.missingstart'],
);

export const getNoMatch = createSelector(getLiteralsState, ({ literals }) => literals['liquid.flows.msg.nomatch']);

export const getTableOrder = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.order'],
);

export const getTableFlowID = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.flowid'],
);

export const getTableStartDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.startdate'],
);

export const getTableEndDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.enddate'],
);

export const getTableActions = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.actions'],
);

export const getTableSort = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.sort'],
);

export const getUpdateConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flowconfiguration.update'],
);

export const getConfigurationSuccessUpdate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.flowconfiguration.success.update'],
);

export const getConfigurationFailedUpdate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.flowconfiguration.unexpectederror'],
);

export const getFlowNamesNoMatch = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.flows.msg.nomatchnames'],
);
